<ng-container *ngIf="changelogContent">
  <markdown [data]="changelogContent"></markdown>
</ng-container>
